export default __webpack_public_path__ + "static/media/sam.5182c453.webp";